import Navbar from "../components/Navbar";
import Trame from "../assets/img/TrameFine.webp";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Carousel1 from "../components/Carousel1";
import ServicePromeesse from "../assets/img/Services_Promesse.webp";
import ServiceMural from "../assets/img/Services-mural.webp";
import ServiceSol from "../assets/img/Services-sol.webp";
import ServiceInterieur from "../assets/img/Services-interieur.webp";
import ServiceExterieur from "../assets/img/peintur-exterieur-facade.webp";
import ServiceEnduit from "../assets/img/Services-enduit.webp";
import ServiceFacade from "../assets/img/Services-facade.webp";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

export default function Services() {
  return (
    <div className="services">
      <Helmet>
        <title>Services – Peinture et décoration à Vannes | Clara Décor</title>
        <meta
          name="description"
          content="Clara Décor propose des services à Vannes et dans le Morbihan : peinture intérieure et extérieure, enduits décoratifs, revêtements muraux et sols, décoration sur-mesure et ravalement de façades."
        />
        <link rel="canonical" href="https://claradecor.fr/services" />
        <meta
          property="og:title"
          content="Services – Clara Décor, peinture et décoration à Vannes"
        />
        <meta
          property="og:description"
          content="Peinture intérieure et extérieure, enduits décoratifs, revêtements muraux et sols, ravalement et décoration sur-mesure. Découvrez tous les services proposés par Clara Décor à Vannes et dans le Morbihan."
        />
        <meta property="og:url" content="https://claradecor.fr/services" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://claradecor.fr/images/og-services.jpg"
        />
        <meta property="og:locale" content="fr_FR" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* JSON-LD pour les services */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "provider": {
        "@type": "Organization",
        "name": "Clara Décor",
        "url": "https://claradecor.fr/",
        "logo": "https://claradecor.fr/images/logo.png"
      },
      "areaServed": "Morbihan",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Services de Clara Décor",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peinture intérieure",
              "description": "Travaux de peinture intérieure de murs, plafonds et boiseries avec finitions et harmonies de couleurs sur-mesure."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Peinture extérieure & ravalement",
              "description": "Ravalement et peinture extérieure avec protection durable, finition soignée et mise en valeur de la façade."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Enduits décoratifs",
              "description": "Application d’enduits décoratifs pour créer textures et ambiances raffinées dans vos espaces intérieurs."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Revêtements muraux et sols",
              "description": "Pose de revêtements muraux et sols avec sélection de matériaux de qualité et finitions soignées."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Décoration sur-mesure",
              "description": "Accompagnement et conseils personnalisés pour la décoration intérieure et la mise en valeur de vos espaces."
            }
          }
        ]
      }
    }
    `}
        </script>
      </Helmet>

      <Navbar />
      <header>
        <div className="header-left">
          <h1>Mes Services</h1>
          <p>
            Clara Décor signe des{" "}
            <span className="color1">espaces uniques</span>, où le savoir-faire
            artisanal se conjugue à la{" "}
            <span className="color1">perfection des finitions</span>. Chaque
            projet est pensé comme une création d’exception, sublimant
            <span className="color1">
              {" "}
              votre intérieur avec précision et exigence
            </span>
            .
          </p>
          <div className="header-btn">
            <button
              className="btn-primary"
              onClick={() => {
                const el = document.getElementById("services");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              }}
              type="button"
            >
              Décourvir mes services{" "}
              <span className="arrow">
                <FaArrowRight />
              </span>
            </button>
          </div>
        </div>
      </header>
      <body>
        <img src={Trame} className="trame" alt="image de trame Clara Décors" />
        <div className="services-title" id="services">
          <h2>Mes Services</h2>

          <p>
            Forte de plus de <span className="color1">10 ans d'expérience</span>
            , je vous accompagne dans tous vos projets de réalisation de
            peinture et de décoration avec un{" "}
            <span className="color1">service personnalisé</span> et un souci du
            détail à chaque étape.
          </p>
        </div>
        <Carousel1 />
        <div className="services-promesse">
          <div className="services-promesse-left">
            <h2>Ma promesse</h2>
            <h3>Un travail soigné & à votre écoute</h3>
            <p>
              À l’écoute de vos envies et attentive à chaque détail, je conçois
              des projets qui reflètent{" "}
              <span className="color1">votre vision avec justesse</span>. Mon
              exigence se traduit ensuite dans la finesse des finitions et la{" "}
              <span className="color1">qualité irréprochable</span> de mon
              travail, afin que chaque espace devienne une signature élégante et
              durable.
            </p>
          </div>
          <div className="services-promesse-right">
            <img src={ServicePromeesse} alt="image représentant un escalier" />
          </div>
        </div>
        <div className="services-block-1" id="revetement-mur">
          <div className="services-block-1-left">
            <img
              src={ServiceMural}
              alt="image représentant un mur avec papier peint"
            />
            <h3>Revêtements muraux</h3>
          </div>
          <div className="services-block-1-right">
            <h3 className="mobile">Revêtements muraux</h3>

            <h3 className="desktop">Revêtements muraux</h3>
            <p>
              Parce que chaque intérieur mérite une attention singulière,{" "}
              <span className="color1">
                j’écoute vos envies et vos inspirations
              </span>{" "}
              afin de vous guider vers le choix de revêtements adaptés et
              élégants. Mon exigence s’exprime ensuite dans un{" "}
              <span className="color1">travail soigné</span>, où chaque finition
              sublime vos murs et confère à votre espace une allure raffinée et
              durable.
            </p>
          </div>
        </div>
        <div className="suggestions">
          <p className="suggestions-text">
            Chaque projet est unique et il est normal d'avoir des{" "}
            <span className="color1">interrogations spécifiques.</span> Si vous
            ne trouvez pas réponse à vos questions, n'hésitez pas à me contacter
            via le formulaire dédié, je vous répondrais dans les plus brefs
            délais, avec toute l'attention que mérite{" "}
            <span className="color1">votre projet.</span>
          </p>
          <Link to={"/contact"} className="btn-secondary">
            Prendre contact
          </Link>
        </div>
        <div className="services-block-2" id="revetement-sol">
          <div className="services-block-2-left">
            <h3 className="mobile">Revêtements de sols</h3>
            <h3 className="desktop">Revêtements de sols</h3>
            <p>
              Chaque sol raconte l’identité d’un lieu. Je prends le temps de
              <span className="color1"> comprendre vos attentes</span> afin de
              vous orienter vers les matières les plus adaptées et les plus
              élégantes. Mon exigence s’exprime ensuite dans{" "}
              <span className="color1">une pose précise et soignée</span>,
              offrant à vos espaces une base solide, harmonieuse et durable.
            </p>
          </div>
          <div className="services-block-2-right">
            <img src={ServiceSol} alt="image représentant un sol en parquet" />
            <h3>Revêtements de sols</h3>
          </div>
        </div>
        <div className="services-block-1" id="intérieure">
          <div className="services-block-1-left">
            <img
              src={ServiceInterieur}
              alt="image représentant un mur avec papier peint"
            />
            <h3>Peinture intérieure</h3>
          </div>
          <div className="services-block-1-right">
            <h3 className="mobile">Peinture intérieure</h3>
            <h3 className="desktop">Peinture intérieure</h3>
            <p>
              Chaque intérieur a sa personnalité. À votre écoute,{" "}
              <span className="color1">
                je capte vos envies et vos inspirations
              </span>{" "}
              pour imaginer des harmonies uniques. Mon travail se traduit
              ensuite par des{" "}
              <span className="color1">finitions impeccables</span>, où chaque
              geste précis révèle la beauté et l’élégance des espaces, pour un
              résultat à la fois raffiné et durable.
            </p>
          </div>
        </div>
        <div className="suggestions">
          <h3>💡Le saviez-vous ? – Les teintes et la perception de l’espace</h3>
          <p>
            Certaines nuances modifient la perception d’une pièce : un plafond
            légèrement plus sombre que les murs peut donner l’illusion d’une
            hauteur plus harmonieuse, tandis qu’une teinte chaude sur un mur
            précis réchauffe immédiatement l’ambiance. Le choix des couleurs va
            bien au-delà de l’esthétique : il sculpte l’espace.
          </p>
        </div>
        <div className="services-block-2" id="exterieure">
          <div className="services-block-2-left">
            <h3 className="mobile">peinture extérieure</h3>
            <h3 className="desktop">peinture extérieure</h3>
            <p>
              Chaque façade a son caractère. À votre écoute,{" "}
              <span className="color1">
                j’étudie vos souhaits et l’architecture de votre bâtiment
              </span>{" "}
              pour proposer des finitions harmonieuses et durables. Mon travail
              se distingue par{" "}
              <span className="color1">une application soignée et précise</span>
              , qui sublime vos façades tout en assurant protection et élégance,
              révélant la beauté et le raffinement de votre patrimoine.
            </p>
          </div>
          <div className="services-block-2-right">
            <img
              src={ServiceExterieur}
              alt="image représentant un mur avec peinture extérieure"
            />
            <h3>peinture extérieure</h3>
          </div>
        </div>
        <div className="services-block-1" id="enduit">
          <div className="services-block-1-left">
            <img
              src={ServiceEnduit}
              alt="image représentant un mur avec enduit"
            />
            <h3>Enduit décoratif</h3>
          </div>
          <div className="services-block-1-right">
            <h3 className="mobile">Enduit décoratif</h3>
            <h3 className="desktop">Enduit décoratif</h3>
            <p>
              À votre écoute,{" "}
              <span className="color1">
                j’imagine des textures et des nuances
              </span>{" "}
              qui structurent vos espaces et{" "}
              <span className="color1">
                mettent en valeur leur personnalité
              </span>
              . Mon travail se traduit par des finitions impeccables, apportant
              à la fois élégance, profondeur et chaleur à vos intérieurs, pour{" "}
              <span className="color1">un résultat raffiné</span> et
              parfaitement harmonieux.
            </p>
          </div>
        </div>
        <div className="suggestions">
          <h3>💡Le saviez-vous ? – Fissures « vivantes » ou « mortes »</h3>
          <p>
            Toutes les fissures ne se valent pas. Une fissure dite « morte » est
            stable et sans risque d’évolution, alors qu’une fissure « vivante »
            continue de bouger et peut fragiliser la façade. Le traitement
            adapté dépend de ce diagnostic, essentiel pour garantir la solidité
            et la durabilité de vos murs.
          </p>
        </div>
        <div className="services-block-2" id="facade">
          <div className="services-block-2-left">
            <h3 className="mobile">Traitement de façade</h3>
            <h3 className="desktop">Traitement de façade</h3>
            <p>
              J’évalue l’état de vos façades pour{" "}
              <span className="color1">proposer des solutions adaptées</span>,
              alliant prévention et réparation. Mon travail se traduit par une
              application rigoureuse et soignée,{" "}
              <span className="color1">
                protégeant durablement votre maison
              </span>{" "}
              tout en sublimant son esthétique, pour un résultat à la fois sûr,
              raffiné et pérenne.
            </p>
          </div>
          <div className="services-block-2-right">
            <img
              src={ServiceFacade}
              alt="image représentant un mur avec traitement de façade"
            />
            <h3>Traitement de façade</h3>
          </div>
        </div>

        <div className="suggestions">
          <h3>💡Le saviez-vous ? – La façade, un véritable bouclier</h3>
          <p>
            Un ravalement de façade ne se limite pas à l’esthétique. Les
            traitements préventifs et curatifs protègent la structure du
            bâtiment contre l’humidité, les fissures et la pollution. Bien
            entretenue, une façade préserve la valeur patrimoniale de votre
            maison et contribue à sa longévité.
          </p>
        </div>
        <div className="prefooter"></div>
      </body>
      <Footer />
    </div>
  );
}
